import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-sidebar-management',
  templateUrl: './sidebar-management.component.html',
  styleUrls: ['./sidebar-management.component.sass']
})
export class SidebarManagementComponent implements OnInit {
  authenticated$: any;

  constructor(
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authenticated$ = this.authService.getAuthenticatedUser();
  }
}
